import React, { useState } from 'react';
import { Box, Paper, Tabs, Tab, Typography } from '@mui/material';
import UserRoles from './UserRoles';
import RolesManagement from './RolesManagement';

/** Admin Tools → Access Control: who has which role, and what each role unlocks. */
const AccessControl = () => {
  const [tab, setTab] = useState(0);

  return (
    <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 1 }}>
      <Typography variant="h6" fontWeight={800}>Access Control</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Manage who can use the restricted parts of the OMS.
      </Typography>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2, borderBottom: '1px solid #e2e8f0' }}>
        <Tab label="User Roles" sx={{ textTransform: 'none', fontWeight: 700 }} />
        <Tab label="Role Permissions" sx={{ textTransform: 'none', fontWeight: 700 }} />
      </Tabs>
      <Box>{tab === 0 ? <UserRoles /> : <RolesManagement />}</Box>
    </Paper>
  );
};

export default AccessControl;
